import {API_STATUS} from "@variables";
import moment from "moment/min/moment-with-locales";

export const pendingState = (state) => {
  state.errors = null;
  state.error = "";
  state.status = API_STATUS.LOADING;
};

export const fulfilledState = (state) => {
  state.errors = null;
  state.error = "";
  state.status = API_STATUS.SUCCESS;
};

export const rejectedState = (state, action) => {
  state.errors = action.payload?.errors || null;
  state.error = action.payload?.message || "";
  state.status = API_STATUS.ERROR;
};

export const getDefaultDates = () => {
  const now = moment();
  const startOfToMonth = now.clone().startOf("month");

  return {
    from: startOfToMonth
      .clone()
      .subtract(5, "months")
      .startOf("month")
      .toDate()
      .toISOString(),
    to: now.clone().endOf("month").toDate().toISOString(),
  };
};

export const formatSessionsByMonth = (rawData, chartsDate) => {
  if (!rawData || rawData.length === 0)
    return {labels: [], simulations: [], avgScores: []};

  let minDate = chartsDate?.from
    ? moment(chartsDate.from).startOf("month")
    : moment.min(rawData.map((item) => moment(item.date))).startOf("month");
  const maxDate = chartsDate?.to
    ? moment(chartsDate.to).startOf("month")
    : moment.max(rawData.map((item) => moment(item.date))).startOf("month");

  const months = [];
  const current = minDate.clone();
  while (current.isSameOrBefore(maxDate)) {
    months.push(current.clone());
    current.add(1, "month");
  }

  while (months.length < 6) {
    minDate = minDate.clone().subtract(1, "month");
    months.unshift(minDate.clone());
  }

  const labels = months.map((m) =>
    months.length >= 8 ? m.format("MM-YYYY") : m.format("MMMM YYYY"),
  );

  const simulations = months.map((m) => {
    const found = rawData.find((item) => moment(item.date).isSame(m, "month"));

    return found ? found.count : 0;
  });

  const avgScores = months.map((m) => {
    const found = rawData.find((item) => moment(item.date).isSame(m, "month"));
    return found ? Number(found.avg_score).toFixed(1) : 0;
  });

  return {labels, simulations, avgScores, raw: rawData};
};

export const formatSessionsByScore = (data) => {
  const filtered = (data || []).filter((item) => item.score !== 0);

  return {
    data: filtered,
    raw: filtered,
  };
};

export const formatSessionsByCountry = (data, sessionScore = "simulations") => {
  let raw = (data || []).filter((item) => item.count);

  if (sessionScore === "simulations") {
    raw = raw.sort((a, b) => (b.count || 0) - (a.count || 0));
  } else {
    raw = raw.sort((a, b) => (b.avg_score || 0) - (a.avg_score || 0));
  }

  if (raw.length > 5) {
    raw = raw.slice(0, 5);
  }

  const labels = raw.map((item) => item.region || item.country || "");
  const simulations = raw.map((item) =>
    item.region || item.country
      ? item.count
        ? Math.round(item.count)
        : null
      : null,
  );
  const avgScores = raw.map((item) =>
    item.region || item.country
      ? item.avg_score
        ? Math.round(Number(item.avg_score) * 10) / 10
        : null
      : null,
  );

  while (labels.length < 5) {
    labels.unshift("");
    simulations.unshift(0);
    avgScores.unshift(0);
  }

  return {labels, simulations, avgScores, raw};
};

export const capitalize = (str) => {
  if (!str) return;

  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const isEqual = (editObj, currentObj) => {
  if (!editObj || !currentObj) return;

  return Object.keys(editObj).every((key) => editObj[key] === currentObj[key]);
};

export const isValidEmail = (email) => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailPattern.test(email);
};

export const getCleanGrade = (feedback) => {
  const match = feedback.match(/_(.*?)_/);

  if (match) {
    return match[1].replace(/[^\wа-яА-ЯёЁ\s]/g, "").trim();
  }

  return "";
};

export const resError = (error) => {
  let message = null;

  if (error?.response?.data?.message) {
    const {message: errorMessage} = error.response.data;
    message = errorMessage;
  } else if (error?.code === "NETWORK_ERROR") {
    message = "Network error. Please check your internet connection.";
  } else if (error?.code === "ECONNABORTED") {
    message = "Request timeout. Please try again.";
  } else if (error?.response?.status === 429) {
    message = "Too many requests. Please try again later.";
  } else if (error?.response?.status === 401) {
    message = "Authentication required. Please log in again.";
  } else if (error?.response?.status === 403) {
    message = "Access denied. You do not have permission for this action.";
  } else if (error?.response?.status === 404) {
    message = "Resource not found.";
  } else if (error?.response?.status >= 500) {
    message = "Server error. Please try again later.";
  }

  return {
    message: error?.response?.data?.message || message,
    errors: error?.response?.data?.errors
      ? error?.response?.data?.errors
      : null,
  };
};

export const checkNameTaken = (obj) => {
  for (const key in obj) {
    if (key === "name") {
      if (obj[key].some((str) => str.includes("has already been taken"))) {
        return true;
      }
    }
  }

  return false;
};
